module.exports = __webpack_public_path__ + "static/Java2017Cert-0ea61962e5009289657f891213f59bf8.png";